import React from "react";
import { useState, useEffect } from "react";
import instance from "../../services/ApiServices";

import { SlCalender } from "react-icons/sl";
import { MdAccessTimeFilled } from "react-icons/md";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import SocialMedia from "./SocialMedia";
import { motion } from "motion/react";
// import Navigation from "../ApiServices/NAvigationServices";

function Footer() {
  const endpoint = "location";
  const endpoint2 = "navigation";

  const [location, setLocation] = useState([]);
  // const [Navdata, setNavdata] = useState([]);

  useEffect(() => {
    instance.get(endpoint).then((res) => {
      const datarcd = res.data[0];
      // console.log("My Image:"+JSON.stringify(datarcd));
      setLocation(datarcd);
      // console.log("Gallery Items :" + JSON.stringify(datarcd));
    });

    instance.get(endpoint2).then((res) => {
      // const navdatarcd = res.data;
      // console.log(navdatarcd)
      // setNavdata(navdatarcd);
    });
  }, []);
  return (
    <div
      id="contactus"
      className="wrapper bg-secondary "
    >
      {location && (
        <>
          <div className="grid sm:grid-cols-1 md:grid-cols-3  gap-24 container py-10 justify-left items-left">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.5,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 0.6 },
                  ease: "easeIn",
                },
              }}
              className="grid grid-flow-row justify-left items-center gap-4 text-white
      h-fit"
            >
              <h1 className="text-lg uppercase font-bold">Opening Hours</h1>
              <div className="flex flex-row gap-2 justify-start items-center">
                <SlCalender />
                <p>{location.opendays}</p>
              </div>
              <div className="flex flex-row gap-2 justify-start items-center">
                <MdAccessTimeFilled />
                <p>{location.open_close_time}</p>{" "}
              </div>
            </motion.div>

            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.5,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 0.6 },
                  ease: "easeIn",
                },
              }}
              className="grid grid-flow-row justify-left items-center gap-4  text-white h-fit"
            >
              <h1 className="text-lg uppercase font-bold">Contact us</h1>
              <div className="flex flex-row gap-2 justify-start items-center">
                <BsFillTelephoneFill />
                <p>{location.phone}</p>
              </div>
              <div className="flex flex-row gap-2 justify-start items-center">
                <MdEmail />
                <p>{location.email}</p>
              </div>
            </motion.div>

            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.5,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 0.6 },
                  ease: "easeIn",
                },
              }}
              className="grid grid-flow-row justify-left items-center gap-4  text-white  h-fit"
            >
              <h1 className="text-lg uppercase font-bold">Shop Address</h1>
              <div className="flex flex-row gap-2 justify-start items-center">
                <p dangerouslySetInnerHTML={{ __html: location.address }} />
              </div>
            </motion.div>
          </div>

          <div className="container  text-white py-10">
            <hr className="border-white border-b-[0.1px]" />
            {/* {your company & social media} */}
            <div className="grid grid-cols-1 md:grid-cols-2 justify-between">
              <SocialMedia />
              <div>
                <p className="py-5 flex justify-end">
                  © 2024 {location.name}. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Footer;
